import findHttpLinks from './findHttpLinks';
import { isCurrentInviteLink } from './parseCurrentInviteLink';

export type LinkSegment = {
  content: string;
  isMatch: boolean;
  isLink: boolean;
};

export default function getLinkSegments(
  content?: string | null,
  publicUrl?: string,
): LinkSegment[] {
  if (!content) {
    return [];
  }

  const segments: LinkSegment[] = [];
  let lastIndex = 0;

  for (const { content: link, index } of findHttpLinks(content)) {
    if (index > lastIndex) {
      segments.push({
        content: content.substring(lastIndex, index),
        isMatch: false,
        isLink: false,
      });
    }

    segments.push({
      content: link,
      isMatch: isCurrentInviteLink(link, publicUrl),
      isLink: true,
    });
    lastIndex = index + link.length;
  }

  if (lastIndex < content.length) {
    const text = content.substring(lastIndex);
    segments.push({
      content: text,
      isMatch: false,
      isLink: false,
    });
  }

  if (segments.length === 0 && content) {
    return [{ content, isMatch: false, isLink: false }];
  }

  return segments;
}
